/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unescaped-entities */
import { useSelector } from 'react-redux';

import { TableTokenCollectors } from '@components/tables/token-collectors';
import { RootState } from '@state/store';
import { getScreenName } from '@utils/user';
import { Box } from '@versumstudios/ui';

export function Collectors() {
  const { holders, creators } = useSelector((state: RootState) => state.token);
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;

  // holders list decorated with `isCreator` and `isYou`.
  // it also allows for table sorting to work because its `key` based.
  // so sorting by `verified` is possible instead of sorting by holder.user[0].user.verified_on_chain
  const parsed = holders.map((user: any) => {
    const { holder } = user;
    return {
      ...user,
      collectorScreenName: getScreenName(
        holder.user[0].user.verified_on_chain,
        holder.user[0].user.screen_name,
        holder.user[0].user.id,
        holder.user[0].user.name
      ),
      isCreator: creators.filter((e: any) => e.wallet.address === holder.address).length > 0,
      isYou: holder.address === viewer,
    };
  });

  return (
    <Box
      css={{
        flexDirection: 'column',
        minHeight: 256,
      }}
    >
      <TableTokenCollectors data={parsed} />
    </Box>
  );
}
